import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { ClientAttachmentId, getUserMailboxInfo } from 'owa-client-ids';

export default function getChangedAttachmentIds(
    event: CalendarEvent,
    originalEvent: CalendarEvent
): { addedAttachmentIds: ClientAttachmentId[]; removedAttachmentIds: ClientAttachmentId[] } {
    const addedAttachmentIds = mapAttachmentsToAttachmentIds(
        getAttachmentsDiff(event.Attachments, originalEvent.Attachments)
    );
    const removedAttachmentIds = mapAttachmentsToAttachmentIds(
        getAttachmentsDiff(originalEvent.Attachments, event.Attachments)
    );
    return { addedAttachmentIds: addedAttachmentIds, removedAttachmentIds: removedAttachmentIds };
}

function getAttachmentsDiff(
    inThisArray: AttachmentType[],
    notInThisArray: AttachmentType[]
): AttachmentType[] {
    return inThisArray.filter(
        attachment =>
            !notInThisArray.some(
                original => attachment.AttachmentId.Id === original.AttachmentId.Id
            )
    );
}

function mapAttachmentsToAttachmentIds(attachments: AttachmentType[]) {
    return attachments.map(attachment => ({
        Id: attachment.AttachmentId.Id,
        mailboxInfo: getUserMailboxInfo(),
    }));
}
